<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-sm-row mb-6">
      <span
        class="text-h6 text-sm-h5 font-weight-bold text-center text-sm-left mb-4 mb-md-0"
      >
        Gerenciar redes sociais
      </span>

      <v-spacer />

      <v-btn
        class="text-none"
        color="primary"
        depressed
        small
        @click="handleCreate()"
      >
        <v-icon left>mdi-plus</v-icon>
        Adicionar nova
      </v-btn>
    </div>

    <loader v-if="loading.content" />

    <v-card v-else class="pa-4 rounded-lg" flat>
      <!-- content -->

      <v-data-table
        :headers="headers"
        :items="socialMedia"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.image`]="{ item }">
          <v-avatar class="mr-2" size="32" color="background">
            <v-img v-if="item.image" :src="item.image" />

            <v-icon v-else color="surface" small> mdi-account-outline </v-icon>
          </v-avatar>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="mr-2"
            color="primary"
            small
            icon
            @click="handleEdit(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn color="primary" small icon @click="handleDelete(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <CreateSocialMedia ref="createSocialMedia" @update="getSocialMedia()" />

    <EditSocialMedia ref="editSocialMedia" @update="getSocialMedia()" />

    <loader-hover v-if="loading.hover" />
  </v-container>
</template>

<script>
import { request } from "@/services";
import CreateSocialMedia from "./partials/createSocialMedia/CreateSocialMedia.vue";
import EditSocialMedia from "./partials/editSocialMedia/EditSocialMedia.vue";

export default {
  components: {
    EditSocialMedia,
    CreateSocialMedia,
  },

  data() {
    return {
      loading: {
        content: true,
        hover: false,
      },
      headers: [
        {
          text: "Ícone",
          value: "image",
        },
        {
          text: "Nome",
          value: "name",
        },
        {
          text: "Endereço",
          value: "link",
        },
        { text: "Ações", value: "actions", width: "6rem" },
      ],
      socialMedia: [],
    };
  },

  beforeMount() {
    this.getSocialMedia();
  },

  methods: {
    async getSocialMedia() {
      const payload = {
        method: "listRedesSociais",
      };

      await request(payload)
        .then(({ data }) => {
          this.socialMedia = data.redesSocias.map((el) => ({
            id: el.id,
            image: this.$store.getters.apiURL + "/" + el.imgRede,
            link: el.linkRede,
            name: el.nomeRede,
          }));
        })
        .finally(() => {
          this.loading.content = false;
        });
    },

    async handleDelete(data) {
      try {
        this.loading.hover = true;

        const payload = {
          method: "deleteRedeSocial",
          idRedeSocial: data.id,
        };

        await request(payload).then(() => {
          this.handleAlert("Rede social removido com sucesso", "success");
          this.getSocialMedia();
        });
      } catch (err) {
        this.handleAlert(err.data.message, "error");
      } finally {
        this.loading.hover = false;
      }
    },

    handleCreate() {
      this.$refs.createSocialMedia.open();
    },

    handleEdit(data) {
      this.$refs.editSocialMedia.open(data);
    },

    handleAlert(title, type) {
      this.$root.$emit("alert", { title, type });
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
